import React, { useEffect, useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { SelecionarData } from 'components'
import { Grid, FormControl, TextField, CircularProgress } from '@material-ui/core'
import AutocompleteNative, { createFilterOptions } from '@material-ui/lab/Autocomplete'
import { useSelector } from 'react-redux'
import { useUsuarioService } from 'hooks/useUsuarioService'
import useStyles from './FormCadeiaDeCustodia.styles'

const filter = createFilterOptions()
const limitFilterOptions = (options, params) => filter(options, params).slice(0, 100)

export const FormCadeiaDeCustodia = (props) => {
  const { cadaverForm, editar } = props
  const usuarioService = useUsuarioService()
  const usuarios = useSelector((state) => state.options.usuarios)
  const [processandoUsuarios, setProcessandoUsuarios] = useState(false)
  const classes = useStyles()

  useEffect(() => {
    usuarioService.listarUsuarios(setProcessandoUsuarios)
  }, [])

  const alteracaoCampoData = useCallback((campo, valor) => {
    if (valor !== 'Invalid date') {
      cadaverForm.setFormState((prev) => ({
        ...prev,
        values: {
          ...prev.values,
          [campo]: valor,
        },
        touched: {
          ...prev.touched,
          [campo]: true,
        },
      }))
    }
  }, [])

  const setDataColeta = useCallback((data) => {
    alteracaoCampoData('dataCol', data)
  }, [alteracaoCampoData])

  const setDataTransporte = useCallback((data) => {
    alteracaoCampoData('dataTrans', data)
  }, [alteracaoCampoData])

  useEffect(() => {
    if (!editar) {
      const date = new Date()
      cadaverForm.setFormState((prev) => ({
        ...prev,
        values: {
          ...prev.values,
          dataCol: date.toString(),
          dataTrans: date.toString(),
        },
      }))
    }
  }, [editar])

  const getUsuarioSelected = useCallback((id) => {
    if (!usuarios) return null
    return usuarios.find((usuario) => usuario.id === id) || null
  }, [usuarios])

  return (
    <div>
      {processandoUsuarios ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Grid className={classes.fieldGroup} alignItems="center" container justifyContent="space-between">
          <Grid className={classes.item} item md={8} sm={8} xs={12}>
            <FormControl style={{ minWidth: '100%', maxWidth: '100%' }}>
              <AutocompleteNative
                name="usuCol"
                noOptionsText="Sem informações"
                options={usuarios || []}
                filterOptions={limitFilterOptions}
                value={
                  cadaverForm.formState.values.usuCol
                    ? getUsuarioSelected(cadaverForm.formState.values.usuCol.id)
                    : null
                }
                onChange={(event, newValue) => {
                  cadaverForm.handleChangeNewValueByNameProperty(event, newValue, 'usuCol')
                }}
                getOptionSelected={(option, value) => option.id === value?.id || option.id === value || option === value}
                getOptionLabel={(option) =>
                  `${option?.nome || ''}${option?.matricula ? ` - ${option.matricula}` : ''}${option?.cargo?.nome ? ` - ${option.cargo.nome.toUpperCase()}` : ''
                  }`
                }
                renderOption={(option) =>
                  `${option?.nome || ''}${option?.matricula ? ` - ${option.matricula}` : ''}${option?.cargo?.nome ? ` - ${option.cargo.nome.toUpperCase()}` : ''
                  }`
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Responsável pela coleta"
                    required
                    InputLabelProps={{
                      shrink: true,
                      className: classes.labelInput,
                    }}
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid className={classes.item} item md={8} sm={8} xs={12}>
            <FormControl style={{ minWidth: '100%', maxWidth: '100%' }}>
              <TextField
                variant="outlined"
                fullWidth
                label="OUTRO RESPONSÁVEL PELA COLETA"
                InputLabelProps={{
                  shrink: true,
                }}
                name="usuarioColetaInput"
                value={cadaverForm.formState.values.usuarioColetaInput || ''}
                onChange={cadaverForm.handleChange}
                disabled={cadaverForm.formState.values.usuCol?.nome?.toUpperCase() !== 'OUTRO'}
              />
            </FormControl>
          </Grid>
          <Grid className={classes.item} item md={3} sm={12} xs={12}>
            <FormControl style={{ minWidth: '100%', maxWidth: '100%' }}>
              <SelecionarData
                dataBD={cadaverForm.formState.values.dataCol}
                name="dataColeta"
                callback={setDataColeta}
                label="Data"
                required
                xs={12}
                sm={12}
                md={12}
              />
            </FormControl>
          </Grid>

          <Grid className={classes.item} item md={8} sm={8} xs={12}>
            <FormControl style={{ minWidth: '100%', maxWidth: '100%' }}>
              <AutocompleteNative
                name="usuTrans"
                noOptionsText="Sem informações"
                options={usuarios || []}
                filterOptions={limitFilterOptions}
                value={
                  cadaverForm.formState.values.usuTrans
                    ? getUsuarioSelected(cadaverForm.formState.values.usuTrans.id)
                    : null
                }
                onChange={(event, newValue) => {
                  cadaverForm.handleChangeNewValueByNameProperty(event, newValue, 'usuTrans')
                }}
                getOptionSelected={(option, value) => option.id === value?.id || option.id === value || option === value}
                getOptionLabel={(option) =>
                  `${option?.nome || ''}${option?.matricula ? ` - ${option.matricula}` : ''}${option?.cargo?.nome ? ` - ${option.cargo.nome.toUpperCase()}` : ''
                  }`
                }
                renderOption={(option) =>
                  `${option?.nome || ''}${option?.matricula ? ` - ${option.matricula}` : ''}${option?.cargo?.nome ? ` - ${option.cargo.nome.toUpperCase()}` : ''
                  }`
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Responsável pelo transporte"
                    required
                    InputLabelProps={{
                      shrink: true,
                      className: classes.labelInput,
                    }}
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid className={classes.item} item md={8} sm={8} xs={12}>
            <FormControl style={{ minWidth: '100%', maxWidth: '100%' }}>
              <TextField
                variant="outlined"
                fullWidth
                label="OUTRO RESPONSÁVEL PELO TRANSPORTE"
                InputLabelProps={{
                  shrink: true,
                }}
                name="usuarioTransporteInput"
                value={cadaverForm.formState.values.usuarioTransporteInput || ''}
                onChange={cadaverForm.handleChange}
                disabled={cadaverForm.formState.values.usuTrans?.nome?.toUpperCase() !== 'OUTRO'}
              />
            </FormControl>
          </Grid>
          <Grid className={classes.item} item md={3} sm={12} xs={12}>
            <FormControl style={{ minWidth: '100%', maxWidth: '100%' }}>
              <SelecionarData
                dataBD={cadaverForm.formState.values.dataTrans}
                name="dataTransporte"
                callback={setDataTransporte}
                label="Data"
                required
                xs={12}
                sm={12}
                md={12}
              />
            </FormControl>
          </Grid>
        </Grid>
      )}
    </div>
  )
}

FormCadeiaDeCustodia.propTypes = {
  cadaverForm: PropTypes.object.isRequired,
  editar: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

